document.addEventListener("DOMContentLoaded", () => {

  /* =====================================================
    FAQ アコーディオン
  ===================================================== */
  const faqItems = document.querySelectorAll(".faq__item");
  faqItems.forEach(item => {
    const btn = item.querySelector(".faq__question");
    if (!btn) return;

    btn.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");

      // 他は閉じる
      faqItems.forEach(i => i.classList.remove("is-open"));

      // クリックしたものだけ開く
      if (!isOpen) {
        item.classList.add("is-open");
      }
    });
  });


  /* =====================================================
    FAQ ナビ（スクロール連動アクティブ）
  ===================================================== */
  const faqBlocks = document.querySelectorAll(".faq__block");
  const faqNavButtons = document.querySelectorAll(".faq__nav-button");

  if (faqBlocks.length && faqNavButtons.length) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            faqNavButtons.forEach(btn => {
              btn.classList.toggle("is-active", btn.getAttribute("href") === `#${id}`);
            });
          }
        });
      },
      { rootMargin: "-40% 0px -40% 0px", threshold: 0 }
    );

    faqBlocks.forEach(block => observer.observe(block));
  }

  // FAQナビクリックでスムーズスクロール
  faqNavButtons.forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      const targetId = btn.getAttribute("href").replace("#", "");
      const targetEl = document.getElementById(targetId);
      if (targetEl) {
        window.scrollTo({ top: targetEl.offsetTop - 80, behavior: "smooth" });
      }
    });
  });


  /* =====================================================
    Guide Tabs（ご利用ガイド切り替え）
  ===================================================== */
  const guideTabs = document.querySelectorAll(".guide-tab");
  const guideSections = document.querySelectorAll(".guide-section");

  if (guideTabs.length && guideSections.length) {
    guideTabs.forEach(tab => {
      tab.addEventListener("click", e => {
        e.preventDefault();
        const targetId = tab.dataset.target;

        // タブ切替
        guideTabs.forEach(t => t.classList.remove("is-active"));
        tab.classList.add("is-active");

        guideSections.forEach(section => {
          section.classList.toggle("is-active", section.id === targetId);
        });

        // ヒーロー下までスクロール
        const hero = document.querySelector(".guide-hero");
        if (hero) {
          window.scrollTo({ top: hero.offsetHeight, behavior: "smooth" });
        }
      });
    });
  }


  /* =====================================================
    ページロード時のハッシュリンク対応
  ===================================================== */
  if (window.location.hash) {
    const hashId = window.location.hash.replace("#", "");

    // FAQブロックに対応
    const faqTarget = document.getElementById(hashId);
    if (faqTarget) {
      window.scrollTo({ top: faqTarget.offsetTop - 80, behavior: "smooth" });
    }

    // FAQナビもアクティブ更新
    faqNavButtons.forEach(btn => {
      btn.classList.toggle("is-active", btn.getAttribute("href") === `#${hashId}`);
    });

    // Guideタブも切替
    guideSections.forEach(section => section.classList.toggle("is-active", section.id === hashId));
    guideTabs.forEach(tab => tab.classList.toggle("is-active", tab.dataset.target === hashId));
  }

});
document.querySelectorAll('.faq__question').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.closest('.faq__item');
    item.classList.toggle('is-open');
  });
});
